import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
import "./styles/globals.css";
import { ClerkProvider } from "@clerk/clerk-react";
// Import your Publishable Key

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

console.log("Intelligentia UI - v1.0.1");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      // @ts-expect-error -- `afterSignOutUrl` on ClerkProvider exists in @clerk/clerk-react v5 but not v4 (currently ^4.30.7). It is silently ignored at runtime; sign-out still falls back to Clerk's default redirect. Remove this directive once the SDK is bumped to v5.
      afterSignOutUrl="/sign-in"
    >
      <App />
    </ClerkProvider>
  </StrictMode>
);
